import React from "react";
import PropTypes from "prop-types";
import css from 'styled-jsx/css';
import { Link, GridRow, GridCol, Heading } from '@lmig/lmds-react';
import sluggify from '@lmig/dotcom-aspect-helpers/sluggify';
import WrapperSizeable from "./Utility/WrapperSizeable";

const { className: entityLinkClass, styles: entityLinkStyle } = css.resolve`
  *{
    display: inline-block;
    font-weight: bold;
  }
`;

const { className: headingClass, styles: headingStyle } = css.resolve`
  .lm-Heading{
    margin-top: -2rem;
    margin-bottom: 2rem;
  }
`;

const OfficeByStateOrAgent = ({
  entityData = {}
}) => {
  const listData = Object.entries(entityData).sort();

  const CleanName = (name) => (name.replaceAll('_', ' '));

  const CreatePath = (state) => {
    const stateName = state.replaceAll('_', '-');
    const path = sluggify(`insurance-agent/${stateName}`);

    return path;
  };

  return (
    <WrapperSizeable>
      <Heading tag="h2" type="h5-bold" className={headingClass}>Search for an insurance agent by state</Heading>
      <GridRow>
        <GridCol>
          <div className="styles" >
            {listData.map(([key, value]) => {
              const name = CleanName(key);

              if (value > 0) {
                const path = CreatePath(key);

                return (
                  <div key={key} >
                    <Link className={entityLinkClass} href={path}>{name}</Link>
                    <div className="entityValue">({value})</div>
                  </div>
                );
              }

              return (
                <div key={key} >
                  <Link className={entityLinkClass} disabled variant="standalone" caretPosition="none">{name}</Link>
                  <div className="entityValue">*</div>
                </div>
              );
            })}
          </div>
        </GridCol>
      </GridRow>
      <div>
        *Certain states do not have offices.
      </div>
      <style jsx>{`@import './AgentListCount.scoped.scss';`}</style>
      {entityLinkStyle}
      {headingStyle}
    </WrapperSizeable>
  );
};

OfficeByStateOrAgent.propTypes = {
  entityData: PropTypes.shape(PropTypes.object.isNotNull),
};

export default OfficeByStateOrAgent;